import { Typography } from "components/atoms";
import { ChoiceType } from "utils/types/OnboardingForms";

interface IProps {
  options: ChoiceType[] | undefined | null;
  value: any;
  name: string;
  onChange: (e: any) => void;
}

export const RadioInput = ({ options, value, name, onChange }: IProps) => {
  return (
    <div className="radio-items-wrapper">
      {options &&
        Array.isArray(options) &&
        options.map((option: any, index: number) => {
          return (
          <div className="radio-wrapper" key={index}>
            {option.hasOwnProperty("Value") ||
            option.hasOwnProperty("value") ? (
              <input
                type="radio"
                value={
                  option.hasOwnProperty("Value") ? option?.Value : option?.value
                }
                name={name}
                checked={
                  option.hasOwnProperty("Value")
                    ? option?.Value === value
                    : option?.value === value
                }
                onChange={() =>
                  option.hasOwnProperty("Value")
                    ? onChange(option?.Value)
                    : onChange(option?.value)
                }
                className="onb-radio-input-custom-style"
              />
            ) : null}
            <Typography
              label={option.Label}
              variant="h7Bold"
              styles="radio-label-custom-style"
            />
          </div>
        )})}
    </div>
  );
};
